import { ModalStyle as Modal, FormikField, Button } from "@hubrise/react-components"
import type { SelectRef } from "@hubrise/react-components"
import { Form, Formik } from "formik"
import _ from "lodash"
import * as React from "react"
import { useTranslation } from "react-i18next"

import useEditor from "shared/hooks/useEditor"
import { SkuId } from "shared/hubrise/ids"
import { IDeal, IDealLine } from "shared/hubrise/models"
import * as DealLine from "shared/hubrise/utils/DealLine"
import * as Sku from "shared/hubrise/utils/Sku"

interface AttachSkuProps {
  onClose: () => void
  deal: IDeal
  dealLine: IDealLine
}

type FormValues = { skuIds: Array<string> }

const AttachSku = ({ onClose, deal, dealLine }: AttachSkuProps): JSX.Element => {
  const { t } = useTranslation()
  const { catalog, editor } = useEditor()
  const $selectRef = React.useRef<SelectRef>(null)

  React.useEffect(() => $selectRef.current?.focus(), [])

  const handleSubmit = ({ skuIds }: FormValues): void => {
    editor.dealLineSku.add(
      deal.id,
      dealLine.id,
      skuIds.map((id) => SkuId(Number(id))),
    )
    onClose()
  }

  const initialValues: FormValues = { skuIds: [] }

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit}>
      <Form>
        <Modal.Header>
          <Modal.Title>
            {deal.name} - #{DealLine.number(deal, dealLine)}
          </Modal.Title>
          <Modal.Close onClick={onClose} />
        </Modal.Header>

        <Modal.Body>
          <FormikField.Select
            ref={$selectRef}
            name="skuIds"
            label={t("deal.skus.attach_modal.label")}
            withMargin
            options={_.sortBy(
              catalog.data.products.flatMap((product) =>
                product.skus.map((sku) => ({
                  label: Sku.fullName(product, sku),
                  value: String(sku.id),
                })),
              ),
              ({ label }) => label,
            )}
            isMulti={true}
            searchable={true}
          />
        </Modal.Body>

        <Modal.Footer>
          <Button variant="primary" type="submit">
            {t("deal.skus.attach_modal.action")}
          </Button>
          <Button variant="empty" onClick={onClose}>
            {t("general.cancel")}
          </Button>
        </Modal.Footer>
      </Form>
    </Formik>
  )
}

export default AttachSku
